export function useSupportLoader() {
  return {};
}
